<template>
  <div :class="{'prop-item': true, 'page-in-props': false}">
    <div class="brand-color-picker">
      <div class="brand-color-sel-group"
           style="display:flex ;align-items:center;">

        <!-- 컬러피커 색상 -->
        <div class="palette-color-sel-group">
          <div class="picker-pre-color"
               ref="preColor"
               @click="clickColor"
               :style="preColor()"></div>
          <!-- <div class="picker-color-rgb" @click="showPalettePicker=true;">aa</div> -->
          <div v-if="showPalettePicker"
               style="position:absolute;z-index:10;top:50%;left:50%;transform:translate(-50%,-50%);box-shadow: 1px 1px 5px #00000040;">
            <div class="color-picker-wrapper"
                 v-on-clickaway="closePalettePicker">
              <color-picker class="color-picker"
                            @input="updateColor"
                            v-model="colors"
                            style="position:relative; box-shadow: unset;">
              </color-picker>
            </div>
          </div>
        </div>
        <div class="color-string"
             :class="{ 'prop-selected': showPalettePicker }"
             @click="clickColor">
          <div>{{ colors.hex }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { directive as onClickaway } from 'vue-clickaway';
  import tinycolor from 'tinycolor2'
  import LpColorDropDown from './LpColorDropDown'
  //import LpColorDropDown from '@/components/components/common/LpColorDropDown'

  export default {
    directives: {
      onClickaway: onClickaway
    },
    components: {
      LpColorDropDown,
      // ChildColorPicker
    },
    props: {
      hex: {
        type: String,
        default: '#ffffff'
      }
    },
    data() {
      return {
        pickerTop: false,               // 피커가 위/아래로 뜨는 위치 결정(true : 위 / false: 아래)
        showPalettePicker: false,
        // 팔레트 RGBA 색상값
        colors : {
          hex: "",
          hex8: "",
          hsl: "",
          hsv: "",
          oldHue: 0,
          rgba: {
            r: 0,
            g: 0,
            b: 0,
            a: 0
          },
          source:"hsva"
        },
        hexColor: ''
      }
    },
    watch: {
      hex (n) {
        this.init();
      }
    },
    created() {
      this.init();
    },
    methods: {
      init () {
        let lpColor = tinycolor(this.hex).toRgbString();
        this.colors.rgba.r = lpColor.r;
        this.colors.rgba.g = lpColor.g;
        this.colors.rgba.b = lpColor.b;
        this.colors.rgba.a = lpColor.a;
        this.colors.hex = this.hex;
        this.$emit('update:hex', this.hex);
      },
      updateColor (res) {
        this.colors = res;
        // this.$emit('update:val', res);
        this.$emit('update:hex', res.hex);
      },
      clickColor(e) {
        //console.log(e.y, screen.);
        // if(document.body.clientHeight < e.y + 300)
        //   this.pickerTop = true;
        // else
        //   this.pickerTop = false;
        this.showPalettePicker=true;
      },
      preColor() {
        return `border:1px solid #ddd; background-color: ${this.colors.hex}`;
      },
      closePalettePicker() {
        this.showPalettePicker = false;
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_variable'
  //@import '~assets/css/ui_main'
  .brand-color-picker
    border 1px solid #EEEEEE
    border-radius 3px
    width 200px
    height 32px

  .color-picker-wrapper
    position relative
    background-color white
  .picker-pre-color
    width 20px
    height 20px
    border-radius 3px

  .picker-pre-color-brand
    width 16px
    height 16px
    border 1px solid #000
    margin-left 4px

  .color-picker
    margin-left 3px
  .picker-close-btn
    width 15px
    height 15px
    // background-color red
    position absolute
    top 53px
    right 11px
  // text-align center
  .page-in-props
    margin-left 5px
  .page-in-props-title
    margin 10px 0 5px 0
    font-size 13px
    font-weight normal
    color #333

  .sel-color-picker-type
    border 1px solid #ff6e49
    display inline-block
    padding 4px 10px
    color #ff6e49
    font-size .9rem

  .selected-type
    background #ff6e49
    color #fff

  .palette-color-sel-group
    /*position relative*/
    margin-left 8px

  .color-string
    height 32px
    width 100%
    margin-left 4px
    padding 9px 10px
    display flex
    align-items center

  .lp-color-picker-title
    font-weight bold
    color #989898
    font-size 0.9rem
    margin-bottom 8px
</style>
